import script from "./RegisterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__